export function dimensionsToString(dimensions) {
  return `Width: ${dimensions.width.ft || 0}' ${dimensions.width.in || 0}" x Height: ${dimensions.height.ft || 0}' ${dimensions.height.in || 0}" `;
}

// data structure for door shapes
export const doorShapes = {
  rectangular: {
    name: 'Rectangular',
    doorShape: 'rectangular',
    numPoints: 4,
    image: '/static/images/rectangular_opening.png',
  },
  angled: {
    name: 'Angled Corners',
    doorShape: 'angled',
    numPoints: 6,
    image: '/static/images/angledcorners_opening.png',
  },
  arched: {
    name: 'Arched Top',
    doorShape: 'arched',
    numPoints: 5,
    image: '/static/images/arched_opening.png',
  },
};

/**
 * finds the unique object having the idValue that matches the idProperty
 *
 * @param idProperty is the property name to match idValue against
 * @param idValue is the value of the idProperty to search for
 * @param returnProperty is the property name to return
 * @returns the value of the returnProperty or null
 *
 * example: getUniqueDoorProperty('numPoints', 6, 'doorShape') = angled
 */
export function getUniqueDoorProperty(idProperty, idValue, returnProperty) {
  return doorShapes[Object.keys(doorShapes).find((key) => {
    if (doorShapes[key][idProperty] === idValue) {
      return true;
    }
    return false;
  })][returnProperty];
}

export function getDoorPointsFromShape(shape) {
  return parseInt(getUniqueDoorProperty('doorShape', shape, 'numPoints'), 10);
}

export function getDoorShapeFromPoints(pointsCount) {
  return getUniqueDoorProperty('numPoints', pointsCount, 'doorShape');
}

export function unpackDimensions(layer = undefined) {
  const width = layer ? layer.physicalWidth : undefined;
  const height = layer ? layer.physicalHeight : undefined;
  // sometimes layer only has some data, no prototype chain
  const pointsCount = layer && typeof layer.getOpeningPointsCount === 'function' ?
    layer.getOpeningPointsCount() :
    4;

  return {
    width: {
      ft: width ? Math.floor(width) : undefined,
      in: width ? Math.round((width - Math.floor(width)) * 12) : undefined,
    },
    height: {
      ft: height ? Math.floor(height) : undefined,
      in: height ? Math.round((height - Math.floor(height)) * 12) : undefined,
    },
    doorShape: getDoorShapeFromPoints(pointsCount),
  };
}

export function packDimensions(dimensions) {
  let widthIn = (parseInt(dimensions.width.ft, 10) || 0) * 12;
  let heightIn = (parseInt(dimensions.height.ft, 10) || 0) * 12;
  widthIn += parseInt(dimensions.width.in, 10) || 0;
  heightIn += parseInt(dimensions.height.in, 10) || 0;

  return {
    physicalWidth: widthIn / 12,
    physicalHeight: heightIn / 12,
    doorShape: dimensions.doorShape,
  };
}

export function setProductPixelDimensions(product, layer) {
  // guard against invalid values
  if (product.ppf && product.ppf > 0 &&
    layer.physicalWidth && layer.physicalWidth > 0 &&
    layer.physicalHeight && layer.physicalHeight > 0) {
    product.width = layer.physicalWidth * product.ppf;
    product.height = layer.physicalHeight * product.ppf;
  }

  return product;
}

/**
 * return the number of points to add + or remove - to support a change in door shape
 *
 * @param fromShape is the original door shape
 * @param toShape is the new door shape
 * @returns the number of points in the difference, positive to add, negative to remove
 */
export function pointsChange(fromShape, toShape) {
  const fromPoints = getDoorPointsFromShape(fromShape);
  const toPoints = getDoorPointsFromShape(toShape);
  return toPoints - fromPoints;
}



// WEBPACK FOOTER //
// ./src/helpers/dimensions.js